import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFileAudio",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, v, f, a) {
  return d(), n("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--file-audio"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "File Audio",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.94 8.44a1.5 1.5 0 0 1 1.56-.354V8a2.5 2.5 0 1 0-5 0v.086a1.5 1.5 0 0 1 2 1.414v.5a1.5 1.5 0 0 1-3 0V8a3.5 3.5 0 1 1 7 0v2a1.5 1.5 0 0 1-3 0v-.5c0-.398.158-.78.44-1.06Zm.706.706A.5.5 0 0 1 6.5 9.5v.5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 .146-.354Zm-4 0A.5.5 0 0 1 2.5 9.5v.5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 .146-.354Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.946.946A1.49 1.49 0 0 1 3 .5h4.25a.5.5 0 0 1 .354.146l2.75 2.75a.5.5 0 0 1 .146.354V10c0 .387-.156.763-.446 1.054A1.49 1.49 0 0 1 9 11.5h-.25a.5.5 0 0 1 0-1H9a.488.488 0 0 0 .346-.154A.488.488 0 0 0 9.5 10V4.5H7a.5.5 0 0 1-.5-.5V1.5H3a.488.488 0 0 0-.346.154A.488.488 0 0 0 2.5 2v1.5a.5.5 0 0 1-1 0V2c0-.387.156-.763.446-1.054ZM9.043 3.5H7.5V1.957L9.043 3.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const A = /* @__PURE__ */ s(c, [["render", m]]);
export {
  A as default
};
//# sourceMappingURL=file-audio.js.map
